import React, { useState, useEffect } from 'react';
import 'devextreme/data/odata/store';
import DataGrid, {
  Column,
  Pager,
  Paging,
  FilterRow,
  Lookup
} from 'devextreme-react/data-grid';
import AgentTasksGrid from '../../components/agentTasksGrid/agentTasksGrid';  
const { REACT_APP_SERVER_URL } = process.env;

const Tasks =() => {



  
  
  return(
  
   <React.Fragment>
    
<AgentTasksGrid/>
  
  </React.Fragment>
);
};


export default Tasks;